import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/authentication/auth.service';
import { Usuario } from 'src/app/authentication/interfaces/interfaces';
import { OrdenesService } from 'src/app/services/transacciones/ordenes.service';
import { CrearPaqueteService } from 'src/app/services/transacciones/crear-paquete.service';
import { OrdenesConvenioService } from 'src/app/services/transacciones/ordenes-convenio.service';
import { PacientesService } from 'src/app/services/personas/pacientes.service';

@Component({
  selector: 'app-crear-factura-convenio',
  templateUrl: './crear-factura-convenio.component.html',
  styleUrls: ['./crear-factura-convenio.component.scss'],
  standalone: false
})
export class CrearFacturaConvenioComponent implements OnInit {
  public ordenes: any[] = [];
  public serviciosOriginales: any[] = [];
  public detalleFactura: any[] = [];
  public cliente: any = {};
  public selectedCliente = '';
  public pacienteslist: any[] = [];
  public guardarCliente = false;
  public spinnerBooleanBuscarData = false;
  public checkIdentificacionSI = true;
  public checkIdentificacionNO = false;
  public randomCedula = '';
  public nuevaIdentificacionPaciente = '05';
  public identificacionPaciente = '';
  public nombrePaciente = '';
  public fechaNacimientoPaciente = '';
  public nuevaEdadPaciente = '';
  public sexoPaciente = '';
  public direccionPaciente = 'GUAYAQUIL';
  public nuevoTelefonoCliente = '';
  public nuevoEmailPaciente = 'cmsalud.manager@gmail.com';
  public pais = '3|593|(000) 00 0000 000';
  public infoAdicional = {};
  public doctor: any = {};
  public tipoDetalle: 'detallado' | 'agrupado' = 'detallado';
  public metodoPago = 'EFECTIVO';
  public metodoPagoSri = '01';
  public subtotalImpuesto = '0.00';
  public subtotalSinImpuesto = '0.00';
  public subtotal = '0.00';
  public iva = '0.00';
  public total = '0.00';
  public cargando = false;
  public mensajeCarga = '';
  public error = '';
  public timeout: any;

  private ordenesParam = '';
  private doctorParam = '';
  public usuario: Usuario;

  get token(): string { return localStorage.getItem('token') || ''; }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private ordenesConvenioService: OrdenesConvenioService,
    private pacientesService: PacientesService,
    private crearPaqueteService: CrearPaqueteService,
    private ordenesService: OrdenesService
  ) {
    this.usuario = authService.loginUsuario;
  }

  ngOnInit(): void {
    const encodedOrdenes = this.route.snapshot.paramMap.get('ordenes') || '';
    this.doctorParam = this.route.snapshot.paramMap.get('doctor') || '';
    this.ordenesParam = this.decodeOrdenes(encodedOrdenes);
    this.cargarOrdenes();
  }

  cargarOrdenes(): void {
    this.cargando = true;
    this.mensajeCarga = 'Cargando órdenes convenio...';
    this.ordenesConvenioService.obtenerFactura(this.token, this.ordenesParam, this.doctorParam).subscribe({
      next: (resp: any) => {
        this.cargando = false;

        this.ordenes = Array.isArray(resp?.ordenes) ? resp.ordenes : [];
        this.serviciosOriginales = Array.isArray(resp?.servicios) ? resp.servicios : [];
        this.cliente = {};
        this.doctor = resp?.doctor || {};
        this.recalcularDetalle();
      },
      error: (err: any) => {
        this.cargando = false;
        const mensaje = err?.error?.message || err?.message || 'No se pudieron cargar las órdenes convenio.';
        this.error = mensaje;
        this.toastr.error(mensaje, 'Atención', { timeOut: 7000, closeButton: true, progressBar: true });
      }
    });
  }

  buscarPaciente(event: any): void {
    const key = event?.key?.toString() || '';
    if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter') return;

    const paciente = event?.target?.value || '';
    this.pacienteslist = [{ datos: 'Cargando....', codigo: '' }];

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.pacientesService.buscarPaciente(this.token, 0, 0, paciente, 'crear-orden').subscribe((resp: any) => {
        this.pacienteslist = [];
        if (resp?.total >= 1) {
          resp.rows.forEach((item: any) => {
            this.pacienteslist.push({
              datos: `CEDULA: ${item.CED_CLI}, NOMBRE: ${item.NOM_CLI}`,
              codigo: item.COD_CLI
            });
          });
        }
      }, () => {
        this.pacienteslist = [];
      });
      clearTimeout(this.timeout);
    }, 1000);
  }

  obtenerClienteSeleccionado(idCliente: string): void {
    if (!idCliente) {
      this.pacienteslist = [];
      this.cliente = {};
      return;
    }

    this.pacientesService.mostrarPacientesNormal(this.token, 'COD_CLI', idCliente).subscribe((resp: any) => {
      const content = Array.isArray(resp?.rows) ? resp.rows : [];
      if (!content.length) {
        this.cliente = {};
        return;
      }

      this.cliente = {
        id: content[0].COD_CLI,
        nombre: content[0].NOM_CLI,
        cedula: content[0].CED_CLI,
        telefono: content[0].TEL_CLI,
        direccion: content[0].DIR_CLI,
        fechaNacimiento: content[0].FEC_CLI,
        email: content[0].EMA_CLI
      };
    }, (err) => {
      this.toastr.error(err?.message || 'Error al obtener cliente.', 'Atención');
    });
  }

  modalAgregarPaciente(modal: any): void {
    this.limpiarFormularioCliente();
    this.modalService.open(modal, {
      backdrop: 'static',
      windowClass: 'modal-mobile-full'
    });
  }

  cerrarModalCliente(): void {
    this.modalService.dismissAll();
    this.limpiarFormularioCliente();
  }

  cambiarSIIdent(): void {
    this.checkIdentificacionNO = false;
    this.randomCedula = '';
  }

  cambiarNOIdent(): void {
    this.checkIdentificacionSI = false;
    const fecha = new Date();
    const aleatorio = Math.floor((Math.random() * 100000000) + 1);
    const codigo = `${fecha.getDate()}${fecha.getMonth() + 1}${fecha.getFullYear()}${fecha.getHours()}${aleatorio}${fecha.getMinutes()}${fecha.getSeconds()}${fecha.getMilliseconds()}`;
    this.randomCedula = codigo.substring(0, 13);
    this.identificacionPaciente = '';
    this.nuevaIdentificacionPaciente = '07';
  }

  buscarDataPersonas(): void {
    if (!this.identificacionPaciente) {
      this.toastr.info('Ingrese identificación del cliente.', 'Atención');
      return;
    }

    if (this.nuevaIdentificacionPaciente === '05' && !this.validarCedulaEcuatoriana(this.identificacionPaciente)) {
      this.toastr.error('La cédula ingresada no es válida.', 'Atención');
      return;
    }

    this.pacientesService.mostrarPacientesNormal(this.token, 'CED_CLI', this.identificacionPaciente).subscribe((resp: any) => {
      const existentes = Array.isArray(resp?.rows) ? resp.rows : [];
      if (existentes.length) {
        this.identificacionPaciente = '';
        this.toastr.error('La identificación ya está registrada. Búsquela en el selector de cliente.', 'Atención', {
          timeOut: 7000,
          closeButton: true,
          progressBar: true
        });
        return;
      }

      this.spinnerBooleanBuscarData = true;
      const consulta = this.nuevaIdentificacionPaciente === '04'
        ? this.pacientesService.buscarDataPersonaRUC(this.identificacionPaciente)
        : this.pacientesService.buscarDataPersona(this.identificacionPaciente);

      consulta.subscribe((respuesta: any) => {
        this.spinnerBooleanBuscarData = false;
        const data = JSON.parse(respuesta);
        if (this.nuevaIdentificacionPaciente === '04') {
          this.nombrePaciente = data?.[0]?.razonsocial || '';
          this.sexoPaciente = 'persona-juridica';
        } else {
          this.nombrePaciente = data?.nombreCompleto || '';
          this.fechaNacimientoPaciente = data?.fechaNacimiento || '';
          this.direccionPaciente = data?.domicilio || 'GUAYAQUIL';
          this.sexoPaciente = data?.sexo || '';
          this.nuevaEdadPaciente = this.calcularEdad(this.fechaNacimientoPaciente).toString();
          this.infoAdicional = data?.infoAdicional || {};
        }
      }, () => {
        this.spinnerBooleanBuscarData = false;
      });
    });
  }

  cambiarFechaNacimiento(): void {
    this.nuevaEdadPaciente = this.calcularEdad(this.fechaNacimientoPaciente).toString();
  }

  guardarPaciente(): void {
    if (this.checkIdentificacionSI && !this.nuevaIdentificacionPaciente) {
      this.toastr.error('Seleccione el tipo de identificación.', 'Atención');
      return;
    }

    if (this.checkIdentificacionSI && !this.identificacionPaciente) {
      this.toastr.error('Ingrese identificación del cliente.', 'Atención');
      return;
    }

    if (this.checkIdentificacionNO) {
      this.identificacionPaciente = this.randomCedula;
    }

    if (!this.nombrePaciente) {
      this.toastr.error('Ingrese nombre del cliente.', 'Atención');
      return;
    }

    if (!this.fechaNacimientoPaciente) {
      this.toastr.error('Ingrese fecha de nacimiento.', 'Atención');
      return;
    }

    if (!this.sexoPaciente) {
      this.toastr.error('Ingrese sexo del cliente.', 'Atención');
      return;
    }

    if (!this.nuevaEdadPaciente) {
      this.toastr.error('Ingrese edad del cliente.', 'Atención');
      return;
    }

    if (!this.nuevoEmailPaciente) this.nuevoEmailPaciente = 'cmsalud.manager@gmail.com';
    if (!this.direccionPaciente) this.direccionPaciente = 'GUAYAQUIL';

    this.guardarCliente = true;
    this.spinnerBooleanBuscarData = true;
    this.pacientesService.guardarPaciente(
      this.nuevaIdentificacionPaciente,
      this.identificacionPaciente,
      this.fechaNacimientoPaciente,
      this.pais,
      this.nuevoTelefonoCliente,
      this.nuevoEmailPaciente,
      this.direccionPaciente,
      this.sexoPaciente,
      this.nuevaEdadPaciente,
      '05',
      '',
      '',
      'GUAYAQUIL',
      this.token,
      this.nombrePaciente,
      this.checkIdentificacionSI ? 'si' : 'no',
      JSON.stringify(this.infoAdicional)
    ).subscribe((resp: any) => {
      this.guardarCliente = false;
      this.spinnerBooleanBuscarData = false;

      if (resp !== 'ok') {
        this.toastr.error(resp || 'No se pudo guardar el cliente.', 'Atención');
        return;
      }

      this.toastr.success('Cliente ingresado correctamente.', 'Atención');
      this.seleccionarClientePorCedula(this.identificacionPaciente);
      this.modalService.dismissAll();
      this.limpiarFormularioCliente();
    }, (err) => {
      this.guardarCliente = false;
      this.spinnerBooleanBuscarData = false;
      this.toastr.error(err?.message || 'No se pudo guardar el cliente.', 'Atención');
    });
  }

  cambiarTipoDetalle(tipo: 'detallado' | 'agrupado'): void {
    this.tipoDetalle = tipo;
    this.recalcularDetalle();
  }

  guardarFactura(): void {
    if (!this.detalleFactura.length) {
      this.toastr.info('No hay servicios para facturar.', 'Atención');
      return;
    }

    if (!this.cliente?.id) {
      this.toastr.info('Seleccione el cliente para la factura.', 'Atención');
      return;
    }

    this.cargando = true;
    this.mensajeCarga = 'Generando factura convenio...';
    const payload = this.crearPayloadFactura();

    this.crearPaqueteService.crearFacturaConvenio(payload, this.token).subscribe({
      next: (resp: any) => {
        const respuesta = typeof resp === 'string' ? JSON.parse(resp) : resp;
        if (!respuesta?.success) {
          this.cargando = false;
          this.toastr.error(respuesta?.error || 'Error al generar factura.', 'Atención', { timeOut: 9000, closeButton: true, progressBar: true });
          return;
        }

        this.enviarSri(respuesta, payload);
      },
      error: (err) => {
        this.cargando = false;
        this.toastr.error(err?.error?.error || err?.message || 'Error al generar factura.', 'Atención', { timeOut: 9000, closeButton: true, progressBar: true });
      }
    });
  }

  volver(): void {
    this.router.navigateByUrl('/sistema/ordenes-convenio');
  }

  private recalcularDetalle(): void {
    this.detalleFactura = this.tipoDetalle === 'agrupado'
      ? this.agruparServicios(this.serviciosOriginales)
      : this.serviciosOriginales.map((servicio) => this.mapServicioFactura(servicio, servicio.paciente || 'Ninguna', 1));

    let subtotalIva = 0;
    let subtotalCero = 0;
    let totalIva = 0;

    this.detalleFactura.forEach((servicio) => {
      const total = Number(servicio.tota || 0);
      if (String(servicio.impuesto) === '12') {
        const base = total / 1.12;
        subtotalIva += base;
        totalIva += total - base;
      } else {
        subtotalCero += total;
      }
    });

    this.subtotalImpuesto = subtotalIva.toFixed(2);
    this.subtotalSinImpuesto = subtotalCero.toFixed(2);
    this.iva = totalIva.toFixed(2);
    this.subtotal = (subtotalIva + subtotalCero).toFixed(2);
    this.total = (subtotalIva + subtotalCero + totalIva).toFixed(2);
  }

  private agruparServicios(servicios: any[]): any[] {
    const agrupados: Record<string, any> = {};
    servicios.forEach((servicio) => {
      const key = `${servicio.codigo}|${servicio.impuesto}`;
      if (!agrupados[key]) {
        agrupados[key] = this.mapServicioFactura(servicio, 'Ninguna', 0);
        agrupados[key].tota = 0;
      }
      agrupados[key].cantidad += 1;
      agrupados[key].tota = Number(agrupados[key].tota) + Number(servicio.valor || 0);
    });

    return Object.values(agrupados).map((servicio: any) => ({
      ...servicio,
      precioSinIva: Number(servicio.tota) / Number(servicio.cantidad || 1)
    }));
  }

  private mapServicioFactura(servicio: any, observacion: string, cantidad: number): any {
    const valor = Number(servicio.valor || 0);
    const impuesto = String(servicio.impuesto || '0');
    const incluidoIva = String(servicio.incluidoIva || '').toUpperCase() === 'SI';
    const precioSinIva = impuesto === '12' && incluidoIva ? valor / 1.12 : valor;

    return {
      codigo: servicio.codigo,
      nombre: servicio.producto,
      cantidad,
      precioSinIva,
      impuesto,
      tota: valor,
      observacion,
      tipo: servicio.tipo || ''
    };
  }

  private crearPayloadFactura(): any {
    const fechaFactura = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Guayaquil' });
    const ordenesIds = this.ordenes.map((orden) => orden.COD_ORD);
    const ordenesNumeros = this.ordenes.map((orden) => orden.NUM_ORD);

    return {
      fechaFactura,
      idCliente: this.cliente.id,
      nombreCliente: this.cliente.nombre,
      cedulaCliente: this.cliente.cedula,
      emailCliente: this.cliente.email || 'cmsalud.manager@gmail.com',
      direccionCliente: this.cliente.direccion || 'GUAYAQUIL',
      idUsuario: this.usuario.idUsuario,
      nombreUsuario: this.usuario.nombre,
      idSucursal: this.usuario.sucursal,
      nombreSucursal: this.usuario.nombreSucursal,
      secuencial: this.usuario.secuencial,
      codigoDoctor: this.doctor.codigo,
      nombreDoctor: this.doctor.nombre,
      metodoPago: this.metodoPago,
      subtotalImpuesto: this.subtotalImpuesto,
      subtotalSinImpuesto: this.subtotalSinImpuesto,
      subtotal: this.subtotal,
      iva: this.iva,
      total: this.total,
      dineroRecibido: this.total,
      dineroEntregado: '0.00',
      codigoTarjeta: '',
      nombreTarjeta: '',
      jsonPagos: JSON.stringify([]),
      observacion: this.doctor.nombre,
      servicios: this.detalleFactura,
      ordenesConvenio: ordenesIds,
      ordenFactura: ordenesNumeros.join(','),
      idOrdenDocumento: ordenesIds.join(',')
    };
  }

  private enviarSri(respuesta: any, payload: any): void {
    this.mensajeCarga = 'Factura generada. Enviando al SRI...';
    this.ordenesService.enviarFactura(
      respuesta.claveAcceso,
      respuesta.emailCliente || payload.emailCliente,
      respuesta.nombreCliente || payload.nombreCliente,
      this.token
    ).subscribe({
      next: (envioSri) => {
        const resultado = this.evaluarEnvioSri(envioSri);
        this.finalizar(respuesta, resultado.success, resultado.mensaje);
      },
      error: (error) => {
        const resultado = this.evaluarEnvioSri(error?.error || error);
        this.finalizar(respuesta, false, resultado.mensaje);
      }
    });
  }

  private evaluarEnvioSri(respuesta: any): { mensaje: string; success: boolean } {
    try {
      const parsed = typeof respuesta === 'string' ? JSON.parse(respuesta) : respuesta;
      return {
        mensaje: parsed?.[2] || parsed?.message || 'Factura generada. Revise el estado del envío SRI.',
        success: parsed?.success !== false && parsed?.status !== 'sri_error',
      };
    } catch {
      return {
        mensaje: 'Factura generada. No se pudo confirmar el envío al SRI.',
        success: false,
      };
    }
  }

  private finalizar(respuesta: any, sriOk = true, mensajeSri = ''): void {
    this.cargando = false;
    if (sriOk) {
      this.toastr.success(mensajeSri || 'Factura convenio generada y autorizada correctamente.', 'Atención', { timeOut: 7000, closeButton: true, progressBar: true });
    } else {
      this.toastr.warning(mensajeSri || 'Factura convenio generada. Revise el estado del envío SRI.', 'Atención', { timeOut: 7000, closeButton: true, progressBar: true });
    }
    const idOrdenDocumento = respuesta.idOrdenDocumento || this.ordenes.map((orden) => orden.COD_ORD).join(',');
    this.abrirDocumentoNode(
      this.ordenesService.generarReciboInterno(this.token, respuesta.numeroFactura, 'Electronica', idOrdenDocumento)
    );
    this.abrirDocumentoNode(
      this.ordenesService.generarFacturaClienteNode(this.token, respuesta.numeroFactura, 'Electronica', idOrdenDocumento)
    );
    this.router.navigateByUrl('/sistema/ordenes-convenio');
  }

  private abrirDocumentoNode(request$: Observable<Blob>): void {
    const pdfWindow = window.open('', '_blank');
    request$.subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        if (pdfWindow) {
          pdfWindow.location.href = url;
        } else {
          window.open(url, '_blank');
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      },
      error: () => {
        pdfWindow?.close();
        this.toastr.error('No se pudo generar el documento.', 'Atención');
      }
    });
  }

  private seleccionarClientePorCedula(cedula: string): void {
    this.pacientesService.mostrarPacientesNormal(this.token, 'CED_CLI', cedula).subscribe((resp: any) => {
      const content = Array.isArray(resp?.rows) ? resp.rows : [];
      if (!content.length) return;

      this.selectedCliente = content[0].COD_CLI;
      this.pacienteslist = [{
        datos: `CEDULA: ${content[0].CED_CLI}, NOMBRE: ${content[0].NOM_CLI}`,
        codigo: content[0].COD_CLI
      }];
      this.cliente = {
        id: content[0].COD_CLI,
        nombre: content[0].NOM_CLI,
        cedula: content[0].CED_CLI,
        telefono: content[0].TEL_CLI,
        direccion: content[0].DIR_CLI,
        fechaNacimiento: content[0].FEC_CLI,
        email: content[0].EMA_CLI
      };
    });
  }

  private limpiarFormularioCliente(): void {
    this.guardarCliente = false;
    this.spinnerBooleanBuscarData = false;
    this.checkIdentificacionSI = true;
    this.checkIdentificacionNO = false;
    this.randomCedula = '';
    this.nuevaIdentificacionPaciente = '05';
    this.identificacionPaciente = '';
    this.nombrePaciente = '';
    this.fechaNacimientoPaciente = '';
    this.nuevaEdadPaciente = '';
    this.sexoPaciente = '';
    this.direccionPaciente = 'GUAYAQUIL';
    this.nuevoTelefonoCliente = '';
    this.nuevoEmailPaciente = 'cmsalud.manager@gmail.com';
    this.infoAdicional = {};
  }

  private calcularEdad(fecha: string): number {
    const hoy = new Date();
    const cumpleanos = new Date(fecha);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    const mes = hoy.getMonth() - cumpleanos.getMonth();
    if (mes < 0 || (mes === 0 && hoy.getDate() < cumpleanos.getDate())) edad--;
    return edad;
  }

  private validarCedulaEcuatoriana(cedula: string): boolean {
    if (!cedula || cedula.length !== 10 || !/^\d{10}$/.test(cedula)) return false;
    const provincia = parseInt(cedula.substring(0, 2), 10);
    if (provincia < 1 || (provincia > 24 && provincia !== 30)) return false;
    if (parseInt(cedula[2], 10) >= 6) return false;
    const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
    let suma = 0;
    for (let i = 0; i < 9; i++) {
      let valor = parseInt(cedula[i], 10) * coeficientes[i];
      if (valor >= 10) valor -= 9;
      suma += valor;
    }
    const residuo = suma % 10;
    const digitoEsperado = residuo === 0 ? 0 : 10 - residuo;
    return parseInt(cedula[9], 10) === digitoEsperado;
  }

  private decodeOrdenes(value: string): string {
    try {
      return atob(value.slice(30, -30));
    } catch {
      return '';
    }
  }
}
